<template>
  <el-dialog
    :title="editForm.id==null||editForm==''?'登记充电枪':'编辑充电枪'"
    :visible="editFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id!=null&&editForm!=''"
    :modal-append-to-body='false'
    :before-close="clearEditForm">
    <el-form :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">
      <el-col :span="12">
        <el-form-item label="运营商" :label-width="formLabelWidth" prop="operatorId">
<!--          <el-select placeholder="运营商" :disabled="showFormFlag =='edit'" v-model="editForm.operatorId" @change="operatorSelect">
            <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
          <el-cascader  size="mini" :disabled="showFormFlag =='edit'"
                        placeholder="运营商"  filterable  ref="cascader"
                        :options="this.setTreeDisable(this.operatorForSelect)"
                        :show-all-levels="false"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        change-on-select
                        @change='handleChangeOperator'
                        v-model="editForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属场站" :label-width="formLabelWidth" prop="stationId">
          <el-select placeholder="选择站" :disabled="showFormFlag =='edit'" v-model="editForm.stationId" @change="stationSelect">
            <el-option v-for="item in stationsForSelect" :key="item.id"
                       v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属设备" :label-width="formLabelWidth" prop="pileId">
          <el-select placeholder="选择桩" :disabled="showFormFlag =='edit'" v-model="editForm.pileId" @change="pileSelect">
            <el-option v-for="item in pilesForSelect" :key="item.id"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="设备编号" :label-width="formLabelWidth" prop="pileCode">
          <el-input disabled v-model="editForm.pileCode"></el-input>
        </el-form-item>
      </el-col>
      <div v-if="showFormFlag == 'edit'">
        <el-col :span="12">
          <el-form-item label="桩编号" :label-width="formLabelWidth" prop="pileCode">
            <el-input placeholder="输入桩编号" disabled v-model="editForm.pileCode">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="枪编号" :label-width="formLabelWidth" prop="gunCode">
            <el-input placeholder="输入枪编号"  v-model="editForm.gunCode">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="枪口号" :label-width="formLabelWidth" prop="gunNum">
            <el-input placeholder="输入枪口号" v-model="editForm.gunNum">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="枪名称" :label-width="formLabelWidth" prop="gunName">
            <el-input placeholder="输入枪名称" v-model="editForm.gunName">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" :label-width="formLabelWidth" prop="state">
            <el-select placeholder="状态" v-model="editForm.state" >
              <el-option label="空闲" value="0"></el-option>
              <el-option label="充电中" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </div>
      <div v-else>
        <el-col :span="12">
          <el-form-item label="录入方式" :label-width="formLabelWidth" prop="addMethod">
            <el-select placeholder="录入方式" v-model="editForm.addMethod" @change="addMethodChange">
              <el-option label="批量新增" value="1"></el-option>
              <el-option label="单个新增" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <div v-if="editForm.addMethod == '1'">
          <el-col :span="12">
            <el-form-item label="起始枪编号" :label-width="formLabelWidth" prop="startGunCode">
              <el-input placeholder="起始枪编号" disabled="disabled" v-model="editForm.startGunCode">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束枪编号" :label-width="formLabelWidth" prop="endGunCode">
              <el-input placeholder="结束枪编号" disabled="disabled" v-model="editForm.endGunCode">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起始枪号" :label-width="formLabelWidth" prop="startGunNum">
              <el-input placeholder="输入起始枪号" v-model="editForm.startGunNum">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束枪号" :label-width="formLabelWidth" prop="endGunNum">
              <el-input placeholder="输入结束枪号" v-model="editForm.endGunNum"></el-input>
            </el-form-item>
          </el-col>
        </div>
        <div v-else-if="editForm.addMethod == '2'">
          <el-col :span="12">
            <el-form-item label="枪口号" :label-width="formLabelWidth" prop="gunNum">
              <el-input placeholder="输入枪口号" v-model="editForm.gunNum">
              </el-input>
            </el-form-item>
          </el-col>
        </div>
        <div v-else></div>
      </div>
      <!--隐藏id-->
      <el-col :span="12" hidden>
        <el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
          <el-input v-model="editForm.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="clearEditForm">取 消</el-button>
      <el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {validateInput,isIntegerNotMust} from '../../../../common/validator'
  export default {
    name: "add",
    data(){
      return{
        editFormRules: {
          operatorId: [{required: true, message: '请选择运营商', trigger: 'blur'}],
          stationId: [{required: true, message: '请选择站', trigger: 'blur'}],
          pileId: [{required: true, message: '请输选择桩', trigger: 'blur'}],
          startGunNum: [{required: true, message: '请输入起始枪号', trigger: 'blur'},{validator:isIntegerNotMust, trigger: 'blur'},{validator:this.startGunNumCheck, trigger: 'blur'}],
          endGunNum: [{required: true, message: '请输入结束枪号', trigger: 'blur'},{validator:isIntegerNotMust, trigger: 'blur'},{validator:this.endGunNumCheck, trigger: 'blur'}],
          //gunNum: [{required: true, message: '请输入枪号', trigger: 'blur'},{validator:isIntegerNotMust, trigger: 'blur'},{max:2, message: '长度不要超过2位', trigger: 'blur'},{validator:this.endGunNumCheck, trigger: 'blur'}],
          gunName: [{required: true, message: '请输入枪名称', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,8,true,true,false,false,false,false,false)
            }, trigger: 'blur'}],
          addMethod: [{required: true, message: '请选择录入方式', trigger: 'blur'}]
        },
        formLabelWidth: '150px',
      }
    },
    props:{
      editForm:{},
      editFormVisible:false,
      showFormFlag:"",
      operatorForSelect:{},
      stationsForSelect:{},
      pilesForSelect:{},
      editSubmitLoading:false
    },
    methods:{
      operatorDisable(item) {
        // 判断是否为潜在运营商
        const flag = (item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved')) ? true : false
        return flag
      },
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.editForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      clearEditForm(){
        let _this = this
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.$emit("editSubmit", this.$refs.editForm)
      },
      operatorSelect(val){
        this.$emit("operatorSelect", val)
      },
      stationSelect(val){
        this.$emit("stationSelect", val)
      },
      pileSelect(val){
        this.$emit("pileSelect", val)
      },
      startGunNumCheck(rule, value, callback){
        this.$emit("startGunNumCheck", rule, value, callback)
      },
      endGunNumCheck(rule, value, callback){
        this.$emit("endGunNumCheck", rule, value, callback)
      },
      addMethodChange(val){
        if (val == 1){
          this.$set(this.editForm, 'gunNum', "")
        }else if (val == 2){
          this.$set(this.editForm, 'startGunCode', "")
          this.$set(this.editForm, 'endGunCode', "")
          this.$set(this.editForm, 'startGunNum', "")
          this.$set(this.editForm, 'endGunNum', "")
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
      height: auto;
    .el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
      line-height: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/charginggunManager/add.vue